import React, {Component} from 'react';

export class AriaStatus extends Component {
    state = {
        bump: false
    };

    componentWillReceiveProps({
        results,
        selectedDestination,
        selectDestinationIndex
    }) {
        let destinationChanged = this.isDestinationUuidChanged(
            selectedDestination,
            this.props.selectedDestination
        );
        let selectedIndexChanged =
            selectDestinationIndex !== this.props.selectDestinationIndex;
        let resultsChanged = this.isResultsChanged(this.props.results, results);
        let hasChanged =
            destinationChanged || selectedIndexChanged || resultsChanged;
        if (hasChanged) {
            this.setState(({bump}) => ({bump: !bump}));
        }
        return hasChanged;
    }

    /**
     * isResultsChanged()
     * Check if results were updated with new entries
     * @param {array} prevResults
     * @param {array} nextResults
     */
    isResultsChanged = (prevResults, nextResults) => {
        prevResults = prevResults || [];
        nextResults = nextResults || [];

        if (prevResults.length !== nextResults.length) {
            return true;
        }
        let nextResultsDict = nextResults.reduce((result, nextResultItem) => {
            result[nextResultItem.uuid] = true;
            return result;
        }, {});
        let changedResult = prevResults.find((prevResultsItem) => {
            return !nextResultsDict[prevResultsItem.uuid];
        });
        return !!changedResult;
    };

    isDestinationUuidChanged = (oldDestination, newDestination) => {
        return (
            (oldDestination && oldDestination.uuid) !==
            (newDestination && newDestination.uuid)
        );
    };

    getContent = (results, messages, destination, index) => {
        if (index > -1 && results[index]) {
            return results[index].term;
        }
        if (destination) {
            return messages.destinationselected.replace(
                '{DESTINATION}',
                destination.term
            );
        }
        if (results) {
            return messages.resultsfound.replace(
                '{NUM_RESULTS}',
                results.length
            );
        }
        return null;
    };

    render() {
        const {
            results,
            selectDestinationIndex,
            selectedDestination,
            messages
        } = this.props;
        const {bump} = this.state;

        let content = this.getContent(
            results,
            messages,
            selectedDestination,
            selectDestinationIndex
        );

        return (
            <div
                className="sr-only"
                aria-atomic="true"
                aria-live="polite"
                role="status"
            >
                {content}
                <span aria-hidden>{bump ? ',' : ',,'}</span>
            </div>
        );
    }
}
